"use strict";

var DEFAULT_TRACKING_URL = 'cdn.usefathom.com';

exports.createTrackingSnippet = function createTrackingSnippet(_ref) {
  var _ref$trackingUrl = _ref.trackingUrl,
      trackingUrl = _ref$trackingUrl === void 0 ? DEFAULT_TRACKING_URL : _ref$trackingUrl,
      siteId = _ref.siteId;

  if (trackingUrl === DEFAULT_TRACKING_URL && !siteId) {
    throw new Error('`siteId` must be provided when using the hosted version of Fathom');
  }

  return "\n    (function(f, a, t, h, o, m){\n      a[h]=a[h]||function(){\n        (a[h].q=a[h].q||[]).push(arguments)\n      };\n      o=f.createElement('script'),\n      m=f.getElementsByTagName('script')[0];\n      o.async=1; o.src=t; o.id='fathom-script';\n      m.parentNode.insertBefore(o,m)\n    })(document, window, '//".concat(trackingUrl, "/tracker.js', 'fathom');\n    ").concat(siteId && "fathom('set', 'siteId', '" + siteId + "');", "\n  ");
};

exports.isWhitelistedHostname = function isWhitelistedHostname() {
  var whitelist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var hostname = arguments.length > 1 ? arguments[1] : undefined;

  if (!Array.isArray(whitelist)) {
    throw new Error('`whitelistHostnames` must be provided as an array');
  }

  if (whitelist.length === 0) {
    return true;
  }

  return whitelist.indexOf(hostname) !== -1;
};